import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import { blue400, grey50,grey200, grey450 } from 'ext-ui/style/colors'
import { css } from 'styled-components'

export default css`
  &.DateFilterDropdown {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 0px;
    z-index: 5;
    padding-bottom: 10px;

    & .container {
      display: flex;
      flex-direction: column;
      box-shadow: 0 4px 10px 0 rgba(25, 16, 16, 0.1);
      background-color: ${styleConstants.colors.white};
      border: 1px solid ${blue400};
      border-radius: 8px;
      overflow: hidden;

      &.small {
        width: 300px;
        height: auto;
      }

      &.large {
        width: 368px;
        height: 500px;
      }
    }

    .option {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      padding: 12px 18px;

      &.active {
        background-color: ${styleConstants.colors.gray_light};
      }

      &:hover,
      &:focus,
      &[aria-selected='true'] {
        background-color: ${grey200};
        outline: none;
      }
    }

    .option-type {
      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.regular,
      )};
    }

    .option-value {
      display: flex;
      white-space: normal;
      ${getFontCss(
        10,
        themeConstants.colors.font_primary,
        styleConstants.fontFamilies.regular,
      )};
    }

    .custom-option {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      padding: 12px 18px;
      background-color: transparent;

      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.regular,
      )};

      &.active {
        background-color: ${styleConstants.colors.gray_light};
      }

      &:hover,
      &:focus,
      &[aria-selected='true'] {
        background-color: ${grey200};
        outline: none;
      }
    }

    .back-button {
      display: flex;
      align-items: center;
      padding: 0 20px;
      height: 42px;
      width: 100%;
      border-bottom: 1px solid ${styleConstants.colors.gray_medium};
      cursor: pointer;
      background: ${styleConstants.colors.gray_lightest};
      ${getFontCss(
        14,
        themeConstants.colors.cta,
        styleConstants.fontFamilies.medium,
      )};
    }

    .reset-container {
      border-radius: 0 0 var(--border-radius) var(--border-radius);
      background: ${grey50};
      padding: 8px;
      border-top: 1px solid ${grey450};
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .reset-button {
      padding: 8px;
    }
  }
`